import React, {useState, useEffect, useRef, useCallback} from 'react';
import {
    Container,
    Button,
    Menu,
    Grid,
    GridColumn,
    Image,
    Header,
    FormField,
    Form,
    Checkbox,
    TextArea,
    FormGroup,
    Dropdown, CardGroup, DimmerDimmable, Card, CardContent, Icon, Dimmer, Loader, Message
} from 'semantic-ui-react'
import {useSelector, useDispatch} from "react-redux";

import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik, setNestedObjectValues} from "formik";

import {
    inquiryDeleteMedia,
    inquiryGet, inquiryGetMedia, inquirySubmit,
} from '../slices/register'

import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';

import moment from 'moment'
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.us"
import {useReactToPrint} from "react-to-print";

const Review = (props) => {

    let contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({contentRef});
    const [loading, setLoading] = useState(false)

    const [selectedDelete, setSelectedDelete] = useState([])
    const [action, setAction] = useState("submit")

    const dispatch = useDispatch();
    const {data, medias} = useSelector((state) => ({
        data: state.register.data,
        medias: state.register.medias,
    }));

    const formatMoney = (number, decPlaces, decSep, thouSep) => {
        let newDecSep = typeof decSep === "undefined" ? "." : decSep;
        let newDecPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces;
        let newThouSep = typeof thouSep === "undefined" ? "," : thouSep;
        let sign = number < 0 ? "-" : "";
        let i = String(
            parseInt((number = Math.abs(Number(number) || 0).toFixed(newDecPlaces)))
        );
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
            "$" +
            sign +
            (j ? i.substr(0, j) + newThouSep : "") +
            i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + newThouSep) +
            (newDecPlaces
                ? newDecSep +
                Math.abs(number - i)
                    .toFixed(newDecPlaces)
                    .slice(2)
                : "")
        );
    }
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {...data},
        validationSchema: Yup.object().shape({}),
        onSubmit: (values) => {
            let inquiryData = {...values}
            console.log(action)
            dispatch(inquirySubmit(window.CONFIG.orgId, inquiryData.id, inquiryData, action, data => {
                if(action === "submit"){
                    props.router.navigate("/thankyou?id=" + data.id)
                }else {
                    props.router.navigate('/getstarted?id=' + data.id)
                }
            }))
        }
    });

    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    const handleDeleteMedia = useCallback(async (file) => {
        setSelectedDelete(file)
        await dispatch(inquiryDeleteMedia(window.CONFIG.orgId, data.id, file.id, async () => {
                await dispatch(inquiryGetMedia(window.CONFIG.orgId, data.id));
                setSelectedDelete(null)
            }
        ));
    }, [dispatch, data])

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth"})
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    useEffect(() => {

        const params = new URLSearchParams(props.router.location.search);
        const id = params.get("id")
        if (id) {
            dispatch(inquiryGet(window.CONFIG.orgId, id,() => {
                dispatch(inquiryGetMedia(window.CONFIG.orgId, id));
                setLoading(false)
            }))
        } else {
            props.router.navigate('/getstarted')
        }
    }, [dispatch, props])
    const isMobile = width <= 768;

    let estimatedPickupDate = validation.values?.estimated_pickup_date ? moment(validation.values.estimated_pickup_date, "MM-DD-YYYY").toDate() : moment().toDate()
    let estimatedDeliveryDate = validation.values?.estimated_delivery_date ? moment(validation.values.estimated_delivery_date, "MM-DD-YYYY").toDate() : moment().toDate()
    let billingContactSelected = validation.values?.billing_information?.billing_contact?.options && validation.values?.billing_information?.billing_contact?.options.find(item => item.selected)
    return (
        <React.Fragment>
            <div ref={contentRef}>
                {/*<Container style={{marginTop: '3em', alignContent: "center"}}>*/}
                <Grid doubling columns={"equal"}
                      style={{
                          padding: 20,
                          alignContent: "center",
                          paddingLeft: isMobile ? 20 : 100,
                          paddingRight: isMobile ? 20 : 100
                      }}>
                    <GridColumn style={{
                        padding: 0,
                        paddingTop: 15,
                        textAlign: isMobile ? "center" : "initial",
                        display: "flex",
                        alignItems: "center"
                    }}>
                        <Image style={{height: 50}}
                               src={process.env.PUBLIC_URL + '/amston_commercial_logo_3Uv_icon.ico'}/>
                        <Header as={'h4'} style={{cursor: "pointer", margin: "0px 15px"}}>
                            Review Request
                        </Header>
                    </GridColumn>
                </Grid>
                <Menu inverted
                      style={{
                          backgroundColor: "#990001",
                          padding: 30,
                          marginBottom: 0,
                          borderRadius: 0
                      }}>
                    <Container style={{paddingTop: "3em"}} ref={contentRef}>
                        <Form onSubmit={async (e) => {
                            e.preventDefault();
                            const validationErrors = await validation.validateForm()
                            if (Object.keys(validationErrors).length > 0) {
                                validation.setTouched(setNestedObjectValues(validationErrors, true));
                                return;
                            }
                            validation.handleSubmit();
                            return false;
                        }}
                              action="#">

                            {validation.values?.success?.show &&
                                <Message positive
                                         header={"Form Saved"}
                                         content={validation.values.success.message}/>}
                            <Header as={"h4"} style={{color: "white"}}>Student Information</Header>
                            <hr/>
                            <br/>
                            <FormGroup widths='equal'>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>First Name<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='First Name'
                                           readOnly
                                           name={"first_name"}
                                           onChange={(e) => {
                                               let student_information = {...validation.values?.student_information}
                                               student_information.first_name = e.target.value
                                               validation.setFieldValue("student_information", student_information)
                                           }}
                                           value={validation.values.student_information?.first_name || ""}/>
                                </FormField>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>Last Name<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='Last Name'
                                           readOnly
                                           name={"last_name"}
                                           onChange={(e) => {
                                               let student_information = {...validation.values?.student_information}
                                               student_information.last_name = e.target.value
                                               validation.setFieldValue("student_information", student_information)
                                           }}
                                           value={validation.values.student_information?.last_name || ""}/>
                                </FormField>
                            </FormGroup>
                            <FormGroup widths='equal'>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>Email<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='Email'
                                           readOnly
                                           name={"email"}
                                           onChange={(e) => {
                                               let student_information = {...validation.values?.student_information}
                                               student_information.email = e.target.value
                                               validation.setFieldValue("student_information", student_information)
                                           }}
                                           value={validation.values.student_information?.email || ""}/>
                                </FormField>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>Phone Number<span
                                        className={"pull-right"}>*required</span></label>

                                    <Cleave
                                        readOnly
                                        aria-label={"Phone Number"}
                                        className="form-control"
                                        id="validationTooltipPhone"
                                        name="phone_number"
                                        placeholder="xxxx xxx xxx"
                                        options={{
                                            phone: true,
                                            phoneRegionCode: "US",
                                            numericOnly: true
                                        }}
                                        inputmode="numeric"
                                        onChange={e => {
                                            let student_information = {...validation.values?.student_information}
                                            student_information.phone_number = e.target.value
                                            validation.setFieldValue("student_information", student_information)
                                        }}
                                        value={validation.values.student_information?.phone_number || ""}
                                    />

                                </FormField>
                            </FormGroup>
                            <FormGroup widths='2'>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>School University<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='School University'
                                           readOnly
                                           name={"school_name"}
                                           onChange={e => {
                                               let student_information = {...validation.values?.student_information}
                                               student_information.school_name = e.target.value
                                               validation.setFieldValue("student_information", student_information)
                                           }}
                                           value={validation.values.student_information?.school_name || ""}/>
                                </FormField>
                            </FormGroup>
                            <br/>
                            <Header as={"h4"} style={{color: "white"}}>Billing Contact (If Different)</Header>
                            <hr/>
                            <br/>
                            <FormGroup widths='2'>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>Select Billing Contact</label>
                                    <Dropdown
                                        disabled
                                        readOnly
                                        fluid
                                        selection
                                        options={
                                            validation.values?.billing_information?.billing_contact?.options && validation.values?.billing_information?.billing_contact?.options.map((form, index) => {
                                                return {key: index, text: form.name, value: form.value}
                                            })}
                                        placeholder='Select one'
                                        onChange={(e, target) => {
                                            let billing_information = {...validation.values?.billing_information}
                                            let options = []
                                            billing_information.billing_contact.options.forEach(option => {
                                                let opt = {...option}
                                                if (opt.value === target.value) {
                                                    opt.selected = true
                                                } else {
                                                    opt.selected = false
                                                }
                                                options.push(opt)
                                            })
                                            billing_information.billing_contact = {
                                                ...billing_information.billing_contact,
                                                options
                                            }
                                            validation.setFieldValue("billing_information", billing_information)
                                        }}
                                        value={billingContactSelected && billingContactSelected?.value}
                                    />
                                    <br/>
                                    <span style={{
                                        color: "white",
                                        fontSize: 13
                                    }}> If you selected alternate billing contact please fill out information below</span>

                                </FormField>
                            </FormGroup>
                            <br/>
                            <FormField>
                                <label> Alternate Billing Contact</label>
                            </FormField>
                            <FormField
                                readOnly={true}
                            >
                                <label>Full Name</label>
                                <input placeholder='Full Name'
                                       readOnly
                                       name={"first_name"}
                                       onChange={e => {
                                           let billing_information = {...validation.values?.billing_information}
                                           billing_information.billing_demographics = {
                                               ...billing_information.billing_demographics,
                                               first_name: e.target.value
                                           }
                                           validation.setFieldValue("billing_information", billing_information)
                                       }}
                                       value={validation.values.billing_information?.billing_demographics?.first_name || ""}/>
                            </FormField>
                            <FormField
                                readOnly={true}
                            >
                                <label>Email</label>
                                <input placeholder='Email'
                                       readOnly
                                       name={"email"}
                                       onChange={e => {
                                           let billing_information = {...validation.values?.billing_information}
                                           billing_information.billing_demographics = {
                                               ...billing_information.billing_demographics,
                                               email: e.target.value
                                           }
                                           validation.setFieldValue("billing_information", billing_information)
                                       }}
                                       value={validation.values.billing_information?.billing_demographics?.email || ""}/>
                            </FormField>
                            <FormField
                                readOnly={true}
                            >
                                <label>Contact Number</label>
                                <Cleave
                                    readOnly
                                    aria-label={"Contact Number"}
                                    className="form-control"
                                    id="validationTooltipPhone"
                                    name="phone_number"
                                    placeholder="xxxx xxx xxx"
                                    options={{
                                        phone: true,
                                        phoneRegionCode: "US",
                                        numericOnly: true
                                    }}
                                    inputmode="numeric"
                                    onChange={e => {
                                        let billing_information = {...validation.values?.billing_information}
                                        billing_information.billing_demographics = {
                                            ...billing_information.billing_demographics,
                                            phone_number: e.target.value
                                        }
                                        validation.setFieldValue("billing_information", billing_information)
                                    }}
                                    value={validation.values.billing_information?.billing_demographics?.phone_number || ""}
                                />
                            </FormField>
                            <FormField
                                readOnly={true}
                            >
                                <label>Relationship to Student</label>
                                <input placeholder='Relationship to Student'
                                       readOnly
                                       name={"relationship"}
                                       onChange={e => {
                                           let billing_information = {...validation.values?.billing_information}
                                           billing_information.billing_demographics = {
                                               ...billing_information.billing_demographics,
                                               relationship: e.target.value
                                           }
                                           validation.setFieldValue("billing_information", billing_information)
                                       }}
                                       value={validation.values.billing_information?.billing_demographics?.relationship || ""}/>
                            </FormField>
                            <br/>
                            <Header as={"h3"} textAlign='center' style={{color: "white"}}>Storage Item
                                Selection</Header>
                            <hr/>
                            <p style={{color: "white"}}>
                                *In-room pick-up and delivery included -- Storage duration included, up to 4 months.
                                Options
                                to
                                store longer or shorter -- Free Boxes & Tape for packing. Boxes are medium category
                                price*
                            </p>
                            <br/>
                            <FormGroup widths='equal'>

                                <FormField
                                    readOnly={true}
                                >
                                    <label>Small Items ($50 Per item/Per term (4 months of storage) </label>
                                    <Dropdown
                                        disabled
                                        readOnly
                                        fluid multiple selection

                                        placeholder='Select one'
                                        name={"small_items"}
                                        options={validation.values.storage_items?.small_items?.options.map((form, index) => {
                                            return {key: index, text: form.name, value: form.value}
                                        })}
                                        onChange={(e, target) => {
                                            let storage_items = {...validation.values?.storage_items}
                                            let options = []
                                            storage_items.small_items.options.forEach(option => {
                                                let opt = {...option}
                                                if (target.value.indexOf(opt.value) !== -1) {
                                                    opt.selected = true
                                                }
                                                options.push(opt)
                                            })
                                            storage_items.small_items = {
                                                ...storage_items.small_items,
                                                options
                                            }
                                            validation.setFieldValue("storage_items", storage_items)
                                        }}
                                        value={validation.values?.storage_items?.small_items?.options && validation.values?.storage_items?.small_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                    />
                                </FormField>
                                <FormField
                                    readOnly={true}>
                                    <label>Total # of Small items<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='e.g., 23'
                                           readOnly
                                           name={"small_items_count"}
                                           onChange={e => {
                                               let storage_items = {...validation.values?.storage_items}
                                               storage_items.small_items_count = e.target.value
                                               validation.setFieldValue("storage_items", storage_items)
                                           }}
                                           value={validation.values.storage_items?.small_items_count?.toString() || ""}/>
                                </FormField>
                            </FormGroup>
                            <FormGroup widths='equal'>

                                <FormField
                                    readOnly={true}
                                >
                                    <label>Medium Items ($55 Per item/Per term (4 months of storage)</label>
                                    <Dropdown
                                        disabled
                                        readOnly
                                        fluid multiple selection
                                        placeholder='Select one'
                                        name={"medium_items"}
                                        options={validation.values.storage_items?.medium_items?.options.map((form, index) => {
                                            return {key: index, text: form.name, value: form.value}
                                        })}
                                        onChange={(e, target) => {
                                            let storage_items = {...validation.values?.storage_items}
                                            let options = []
                                            storage_items.medium_items.options.forEach(option => {
                                                let opt = {...option}
                                                if (target.value.indexOf(opt.value) !== -1) {
                                                    opt.selected = true
                                                }
                                                options.push(opt)
                                            })
                                            storage_items.medium_items = {
                                                ...storage_items.medium_items,
                                                options
                                            }
                                            validation.setFieldValue("storage_items", storage_items)
                                        }}
                                        value={validation.values?.storage_items?.medium_items?.options && validation.values?.storage_items?.medium_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                    />
                                </FormField>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>Total # of Medium Items<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='e.g., 23'
                                           readOnly
                                           name={"medium_items_count"}
                                           onChange={e => {
                                               let storage_items = {...validation.values?.storage_items}
                                               storage_items.medium_items_count = e.target.value
                                               validation.setFieldValue("storage_items", storage_items)
                                           }}
                                           value={validation.values.storage_items?.medium_items_count?.toString() || ""}/>
                                </FormField>
                            </FormGroup>
                            <FormGroup widths='equal'>

                                <FormField
                                    readOnly={true}
                                >
                                    <label>Large Items ($65 Per item/Per term (4 months of storage)</label>
                                    <Dropdown
                                        disabled
                                        readOnly
                                        fluid multiple selection
                                        placeholder='Select one'
                                        name={"large_items"}
                                        options={validation.values.storage_items?.large_items?.options.map((form, index) => {
                                            return {key: index, text: form.name, value: form.value}
                                        })}
                                        onChange={(e, target) => {
                                            let storage_items = {...validation.values?.storage_items}
                                            let options = []
                                            storage_items.large_items.options.forEach(option => {
                                                let opt = {...option}
                                                if (target.value.indexOf(opt.value) !== -1) {
                                                    opt.selected = true
                                                }
                                                options.push(opt)
                                            })
                                            storage_items.large_items = {
                                                ...storage_items.large_items,
                                                options
                                            }
                                            validation.setFieldValue("storage_items", storage_items)
                                        }}
                                        value={validation.values?.storage_items?.large_items?.options && validation.values?.storage_items?.large_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                    />
                                </FormField>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>Total # of Large Items<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='e.g., 23'
                                           readOnly
                                           name={"large_items_count"}
                                           onChange={e => {
                                               let storage_items = {...validation.values?.storage_items}
                                               storage_items.large_items_count = e.target.value
                                               validation.setFieldValue("storage_items", storage_items)
                                           }}
                                           value={validation.values.storage_items?.large_items_count?.toString() || ""}/>
                                </FormField>
                            </FormGroup>
                            <FormGroup widths={2}>

                                <FormField
                                    readOnly={true}
                                >
                                    <label>XL Items ($80 Per item/Per term (4 months of storage)</label>
                                    <Dropdown
                                        disabled
                                        readOnly
                                        fluid multiple selection
                                        placeholder='Select one'
                                        name={"xl_items"}
                                        options={validation.values.storage_items?.xl_items?.options.map((form, index) => {
                                            return {key: index, text: form.name, value: form.value}
                                        })}
                                        onChange={(e, target) => {
                                            let storage_items = {...validation.values?.storage_items}
                                            let options = []
                                            storage_items.xl_items.options.forEach(option => {
                                                let opt = {...option}
                                                if (target.value.indexOf(opt.value) !== -1) {
                                                    opt.selected = true
                                                }
                                                options.push(opt)
                                            })
                                            storage_items.xl_items = {
                                                ...storage_items.xl_items,
                                                options
                                            }
                                            validation.setFieldValue("storage_items", storage_items)
                                        }}
                                        value={validation.values?.storage_items?.xl_items?.options && validation.values?.storage_items?.xl_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                    />
                                </FormField>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>Total # of XL Items<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='e.g., 23'
                                           readOnly
                                           name={"xl_items_count"}
                                           onChange={e => {
                                               let storage_items = {...validation.values?.storage_items}
                                               storage_items.xl_items_count = e.target.value
                                               validation.setFieldValue("storage_items", storage_items)
                                           }}
                                           value={validation.values.storage_items?.xl_items_count?.toString() || ""}/>
                                </FormField>
                            </FormGroup>
                            <FormGroup widths='equal'>

                                <FormField
                                    readOnly={true}
                                >
                                    <label>XXL Items ($125 Per item/Per term (4 months of storage)</label>
                                    <Dropdown
                                        disabled
                                        readOnly
                                        fluid multiple selection
                                        placeholder='Select one'
                                        name={"xxl_items"}
                                        options={validation.values.storage_items?.xxl_items?.options.map((form, index) => {
                                            return {key: index, text: form.name, value: form.value}
                                        })}
                                        onChange={(e, target) => {
                                            let storage_items = {...validation.values?.storage_items}
                                            let options = []
                                            storage_items.xxl_items.options.forEach(option => {
                                                let opt = {...option}
                                                if (target.value.indexOf(opt.value) !== -1) {
                                                    opt.selected = true
                                                }
                                                options.push(opt)
                                            })
                                            storage_items.xxl_items = {
                                                ...storage_items.xxl_items,
                                                options
                                            }
                                            validation.setFieldValue("storage_items", storage_items)
                                        }}
                                        value={validation.values?.storage_items?.xxl_items?.options && validation.values?.storage_items?.xxl_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                    />
                                </FormField>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>Total # of XXL Items<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='e.g., 23'
                                           readOnly
                                           name={"xxl_items_count"}
                                           onChange={e => {
                                               let storage_items = {...validation.values?.storage_items}
                                               storage_items.xxl_items_count = e.target.value
                                               validation.setFieldValue("storage_items", storage_items)
                                           }}
                                           value={validation.values.storage_items?.xxl_items_count?.toString() || ""}/>
                                </FormField>
                            </FormGroup>
                            <FormGroup widths='equal'>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>XXXL Items ($200 Per item/Per term (4 months of storage)</label>
                                    <Dropdown
                                        disabled
                                        readOnly
                                        fluid multiple selection
                                        placeholder='Select one'
                                        name={"xxxl_items"}
                                        options={validation.values.storage_items?.xxxl_items?.options.map((form, index) => {
                                            return {key: index, text: form.name, value: form.value}
                                        })}
                                        onChange={(e, target) => {
                                            let storage_items = {...validation.values?.storage_items}
                                            let options = []
                                            storage_items.xxxl_items.options.forEach(option => {
                                                let opt = {...option}
                                                if (target.value.indexOf(opt.value) !== -1) {
                                                    opt.selected = true
                                                }
                                                options.push(opt)
                                            })
                                            storage_items.xxxl_items = {
                                                ...storage_items.xxxl_items,
                                                options
                                            }
                                            validation.setFieldValue("storage_items", storage_items)
                                        }}
                                        value={validation.values?.storage_items?.xxxl_items?.options && validation.values?.storage_items?.xxxl_items?.options.filter(item => item.selected)?.map(item => item.value)}
                                    />
                                </FormField>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>Total # of XXXL Items<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='e.g., 23'
                                           readOnly
                                           name={"xxxl_items_count"}
                                           onChange={e => {
                                               let storage_items = {...validation.values?.storage_items}
                                               storage_items.xxxl_items_count = e.target.value
                                               validation.setFieldValue("storage_items", storage_items)
                                           }}
                                           value={validation.values.storage_items?.xxxl_items_count?.toString() || ""}/>
                                </FormField>
                            </FormGroup>
                            <br/>
                            <Header as={"h3"} textAlign='center' style={{color: "white"}}>Add Picture Items</Header>
                            <hr/>
                            <br/>

                            {
                                medias ?
                                    <CardGroup centered itemsPerRow={4}>
                                        {medias.medias.map((media, index) => {
                                            return <DimmerDimmable key={index} as={Card}
                                                                   dimmed={selectedDelete?.id === media.id}>
                                                <CardContent
                                                    className="text-center"
                                                    style={{
                                                        overflow: "hidden",
                                                        padding: 0,
                                                        backgroundColor: "aliceblue"
                                                    }}>
                                                    {/*<Icon link name='times' color='black'*/}
                                                    {/*      style={{*/}
                                                    {/*          position: "absolute",*/}
                                                    {/*          right: 5,*/}
                                                    {/*          top: 5,*/}
                                                    {/*          textShadow: "2px 2px 10px white"*/}
                                                    {/*      }}*/}
                                                    {/*      onClick={() => handleDeleteMedia(media)}/>*/}
                                                    <img
                                                        src={media.thumbnail_media_url}
                                                        alt=""
                                                        style={{
                                                            width: 300,
                                                            height: 200,
                                                            objectFit: 'cover',
                                                            cursor: "pointer"
                                                        }}
                                                        className="img-fluid"
                                                    />

                                                    <Dimmer active={selectedDelete?.id === media.id} page={false}>
                                                        <Loader>Deleting</Loader>
                                                    </Dimmer>
                                                </CardContent>
                                            </DimmerDimmable>
                                        })
                                        }

                                    </CardGroup> : null
                            }

                            <br/>
                            <br/>
                            <FormGroup widths='2'>
                                <FormField
                                    readOnly={true}
                                >
                                    <label>Total Estimated Cost<span
                                        className={"pull-right"}>*required</span></label>
                                    <input placeholder='Total Estimated Cost'
                                           readOnly
                                           name={"total_estimated_cost"}
                                           onChange={validation.handleChange}
                                           onBlur={validation.handleBlur}
                                           value={formatMoney(validation.values.total_estimated_cost)}

                                    />
                                </FormField>
                            </FormGroup>
                            <FormField
                                readOnly={true}
                                label={"Misc. Items not listed or any other helpful information"}
                                rows={10}
                                control={TextArea}
                                name="misc_items_not_listed"
                                onChange={e => {
                                    let storage_items = {...validation.values?.storage_items}
                                    storage_items.misc_items_not_listed = e.target.value
                                    validation.setFieldValue("storage_items", storage_items)
                                }}
                                value={validation.values.storage_items?.misc_items_not_listed || ""}
                            />

                            <FormField
                                readOnly={true}
                            >
                                <label>Estimated Pick-up Date:<span
                                    className={"pull-right"}>*required</span></label>
                                <input readOnly
                                       name={"estimated_pickup_date"}
                                       value={validation.values.estimated_pickup_date}/>
                                <br/>
                                <span style={{
                                    color: "white",
                                    fontSize: 13
                                }}> Office will call to confirm schedule in advance</span>
                            </FormField>

                            <FormField
                                readOnly={true}
                            >
                                <label>Estimated Delivery Date:<span
                                    className={"pull-right"}>*required</span></label>
                                <input readOnly
                                       name={"estimated_delivery_date"}
                                       value={validation.values.estimated_delivery_date}/>
                                <br/>
                                <span style={{
                                    color: "white",
                                    fontSize: 13
                                }}> Office will call to confirm schedule in advance</span>
                            </FormField>
                            <FormField
                                readOnly={true}
                            >
                                <label>How Did You Hear About Us<span
                                    className={"pull-right"}>*required</span></label>
                            </FormField>
                            {validation.values.referral_information?.how_did_you_hear_about_us?.options.map((opt, key) => {
                                return <FormField
                                    key={key}
                                    readOnly={true}
                                >
                                    <Checkbox label={opt.name}
                                              readOnly
                                              name={opt.name}
                                              value={opt.value}
                                              checked={opt.selected}
                                              onChange={(e, data) => {
                                                  let referral_information = {...validation.values?.referral_information}

                                                  let options = []
                                                  referral_information.how_did_you_hear_about_us.options.forEach(option => {
                                                      let opt = {...option}
                                                      if (opt.value === data.value) {
                                                          opt.selected = data.checked
                                                      }
                                                      options.push(opt)
                                                  })
                                                  referral_information.how_did_you_hear_about_us = {
                                                      ...referral_information.how_did_you_hear_about_us,
                                                      options
                                                  }
                                                  validation.setFieldValue("referral_information", referral_information)
                                              }}
                                    />
                                </FormField>
                            })}
                            <FormField
                                readOnly={true}
                            >
                                <label>If you selected promotional flyer type name of student you received it from<span
                                    className={"pull-right"}>*required</span></label>
                                <input placeholder=''
                                       readOnly
                                       name="promotional_flyer_student_name"
                                       onChange={e => {
                                           let referral_information = {...validation.values?.referral_information}
                                           referral_information.promotional_flyer_student_name = e.target.value
                                           validation.setFieldValue("referral_information", referral_information)
                                       }}
                                       value={validation.values.referral_information?.promotional_flyer_student_name || ""}/>
                                <span style={{
                                    color: "white",
                                    fontSize: 13
                                }}> Type N/A if you selected another option</span>

                            </FormField>
                            <hr/>
                            <div style={{textAlign: 'center', paddingTop: "3em"}}>
                                <Button
                                    className={'menu_button'}
                                    onClick={() => {
                                        setAction("back")
                                        validation.handleSubmit();
                                    }}
                                    style={{paddingLeft: 40, paddingRight: 40, margin: 10}}
                                >
                                    Back to Form
                                </Button>
                                <Button
                                    className={'menu_button'}
                                    style={{paddingLeft: 40, paddingRight: 40, margin: 10}}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        reactToPrintFn()
                                    }
                                    }
                                >
                                    Print
                                </Button>
                                <Button
                                    className={'menu_button'}
                                    aria-label={'submit'}
                                    type="submit"
                                    style={{paddingLeft: 40, paddingRight: 40, margin: 10}}
                                    onClick={() => {
                                        setAction("submit")
                                        validation.handleSubmit();
                                    }}
                                >
                                    Submit
                                </Button>
                            </div>
                        </Form>


                    </Container>
                </Menu>
            </div>
            <footer>
                <Grid doubling columns={"equal"}
                      style={{
                          paddingLeft: isMobile ? 10 : 100,
                          paddingRight: isMobile ? 10 : 100,
                          alignContent: "center"
                      }}>

                    <GridColumn style={{
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Header as={'h4'} style={{cursor: "pointer"}}>
                            <Image style={{height: 150, width: "auto"}}
                                   src={process.env.PUBLIC_URL + '/Amston-Commercial-Logo_512_Black_and_white.png'}/>
                        </Header>
                    </GridColumn>
                    <GridColumn style={{
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "initial",
                        float: "right"
                    }}>
                        <div style={{float: "right"}}>
                            <p className={"contact"}><Icon name='phone' size='large'/> (860) 920-5377</p>
                            <p className={"contact"}><Icon name='map pin' size='large'/> Wallingford, CT</p>
                            <p className={"contact"}><Icon name='mail' size='large'/> info @ amstonstudentstorage
                                .com
                            </p>
                        </div>
                    </GridColumn>
                </Grid>
                <p>
                    Amston Student Storage 2025
                </p>
            </footer>
        </React.Fragment>
    );
};

export default withRouter(Review);
